import { useState, useEffect } from 'react';

import * as http from 'utils/http';
import config from 'config';
import serialize from 'utils/serialize';

const queryStr = serialize({
  groups: 'CustomerService',
  page_size: 0,
  fields: 'id,first_name,last_name',
});

const useStaffUsers = () => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);

  useEffect(() => {
    async function fetchData() {
      const staffUsers = await http.get(`${config.API_URL}staff_users/?${queryStr}`);
      setData(staffUsers);
      setLoading(false);
    }
    fetchData();
  }, []);

  return { data, loading };
};

export { useStaffUsers };
